module.exports = __webpack_public_path__ + "img/tami.d6f9f2f0.gif";